// extracted by mini-css-extract-plugin
export default {"OrderDisclaimerRDP":"BSlZnepgvG"};